import { GridColDef } from "@mui/x-data-grid";
import { useCallback } from "react";
import api, { NameValueItem, RetailerProductDto } from "../../../api";
import { PaginatedDataGrid, PaginationData } from "../../controls";
import { arrayNotEmpty } from "../../utils";

export interface RetailerProductsGridProps {
  retailerId?: string;
  onRowsSelected: (rows: RetailerProductDto[]) => void;
}

export const RetailerProductsGrid = (props: RetailerProductsGridProps) => {
  const { retailerId, onRowsSelected } = props;

  const loadData = useCallback(async (page: number, size: number, sort: string, filter: string): Promise<PaginationData<RetailerProductDto>> => {
    if (retailerId) {
      return await api.retailerProduct.find({ page, size, sort, retailerId, sku: filter } as any);
    }
    return { data: [], count: 0 } as any;
  }, [retailerId]);

  const formatTokens = (tokens?: NameValueItem[]) : string => {
    if (tokens && arrayNotEmpty(tokens)) {
      return tokens.map(token => `${token.name}=${token.value}`).join(";");
    }
    return "";
  }

  const columns: GridColDef<RetailerProductDto>[] = [
    { field: "retailer.name", headerName: "Retailer", minWidth: 100, flex: 200, editable: false, sortable: true, filterable: false, valueGetter: (p) => p.row.retailer?.name || "" },
    { field: "product.sku", headerName: "Product", minWidth: 100, flex: 200, editable: false, sortable: true, filterable: false, valueGetter: (p) => p.row.product?.sku || "" },
    { field: "exclude", headerName: "Exclude", width: 80, editable: false, sortable: false, filterable: false, align: "center", headerAlign: "center", valueGetter: (p) => ((p.row.settings?.exclude ?? false) ? "Yes" : "No") },
    { field: "tokens", headerName: "Tokens", minWidth: 200, flex: 400, editable: false, sortable: false, filterable: false, valueGetter: (p) => formatTokens(p.row.settings?.tokens) },
  ];

  return <PaginatedDataGrid name="RetailerProducts" loadData={loadData} columns={columns} onRowsSelected={onRowsSelected} showFilter checkboxSelection getRowId={(row) => `${row?.retailerId};${row?.productId}` }/>;
};
